import {
  Link,
  Tooltip,
  TooltipProps,
  Typography,
  TypographyOwnProps,
} from "@mui/material";

type AccessDeniedTooltipContentProps = {
  title?: string;
  mailToLinkProps?: {
    color?: TypographyOwnProps["color"];
  };
  titleOverwrite?: React.ReactNode;
};

export const AccessDeniedTooltipContent = ({
  title,
  mailToLinkProps,
  titleOverwrite,
}: AccessDeniedTooltipContentProps) => (
  <Typography variant="caption" color="text.secondary" textAlign="center">
    {titleOverwrite ? (
      titleOverwrite
    ) : (
      <>
        {title ? title : "You don't have permission to use this feature"}.
        Contact us at{" "}
        <Link
          href="mailto:support@tsc.ai"
          color="primary.main"
          {...mailToLinkProps}
        >
          support@tsc.ai
        </Link>
        .
      </>
    )}
  </Typography>
);

export const AccessRequiredTooltip = ({
  children,
  hasAccessTooltipTitle = null,
  hasAccessTooltipPropsOverwrite,
  restrictedAccessTooltipContentProps,
  restrictedAccessTooltipPropsOverwrite,
  hasAccess,
  ...props
}: {
  children: React.ReactNode;
  hasAccess: boolean;
  hasAccessTooltipTitle?: React.ReactNode;
  hasAccessTooltipPropsOverwrite?: Omit<TooltipProps, "title" | "children">;
  restrictedAccessTooltipContentProps?: AccessDeniedTooltipContentProps;
  restrictedAccessTooltipPropsOverwrite?: Omit<
    TooltipProps,
    "title" | "children"
  >;
} & Omit<TooltipProps, "title">) => (
  <Tooltip
    title={
      !hasAccess ? (
        <AccessDeniedTooltipContent {...restrictedAccessTooltipContentProps} />
      ) : hasAccessTooltipTitle !== null ? (
        hasAccessTooltipTitle
      ) : (
        ""
      )
    }
    {...props}
    {...(hasAccess
      ? hasAccessTooltipPropsOverwrite
      : restrictedAccessTooltipPropsOverwrite)}
  >
    {children}
  </Tooltip>
);
